import { render, staticRenderFns } from "./BandeiraElo.vue?vue&type=template&id=5d29bbf1&"
import script from "./BandeiraElo.vue?vue&type=script&lang=js&"
export * from "./BandeiraElo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports